/* eslint-disable @typescript-eslint/no-explicit-any */

import { QueryParams, StringParam } from 'use-query-params';
import { IPaginationQueryParams, getPaginationQueryParams } from '../common/constants/pagination';
import { OrderDirection } from '../common/enums/order-direction.enum';
import { IHOCQueryProps } from '../common/interfaces/IHOCQueryProps';
import AdminDashboard from './AdminDashboard';

export interface AdminDashboardQueryProps extends IPaginationQueryParams {
    search?: string;
}

export type AdminDashboardBasicProps = IHOCQueryProps<AdminDashboardQueryProps>;

const DEFAULT_QUERY_PARAMS = getPaginationQueryParams({
    orderBy: 'created_at',
    orderDirection: OrderDirection.DESC,
});

const AdminDashboardWithQueryParams = () => {
    const queryConfig = {
        ...DEFAULT_QUERY_PARAMS,
        search: StringParam,
    };

    return (
        <QueryParams config={queryConfig}>
            {(props: any) => {
                return <AdminDashboard {...props} />;
            }}
        </QueryParams>
    );
};

export default AdminDashboardWithQueryParams;
